/* eslint-disable max-len */
/* eslint-disable no-plusplus */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  cart: [],
  cartUpdated: false,
  isDineInMode: false,
  tableSelected: null,
  restaurantSelected: null,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const product = action.payload;
      const existingProduct = state.cart.find((item) => item.productId === product.productId);

      if (!existingProduct) {
        state.cart.push({ ...product, quantity: 1 });
      } else {
        existingProduct.quantity++;
      }
      state.cartUpdated = true;
    },
    removeFromCart: (state, action) => {
      state.cart = state.cart.filter((item) => item.productId !== action.payload.id);
      state.cartUpdated = true;
    },
    increaseQuantity: (state, action) => {
      const { id } = action.payload;
      const product = state.cart.find((item) => item.productId === id);
      if (product) {
        product.quantity++;
        state.cartUpdated = true;
      }
    },
    decreaseQuantity: (state, action) => {
      const { id } = action.payload;
      const product = state.cart.find((item) => item.productId === id);
      if (product && product.quantity > 1) {
        product.quantity--;
        state.cartUpdated = true;
      }
    },
    clearCart: (state) => {
      state.cart = [];
      state.cartUpdated = true;
    },
    setCart: (state, action) => {
      state.cart = action.payload;
      state.cartUpdated = true;
    },
    resetCartUpdated: (state) => {
      state.cartUpdated = false;
    },
    toggleDineInMode: (state, action) => {
      state.isDineInMode = action.payload;
    },
    setTableSelected: (state, action) => {
      state.tableSelected = action.payload; // Set selected table
    },
    setRestaurantSelected: (state, action) => {
      state.restaurantSelected = action.payload; // Set selected restaurant
    },
  },

});

export const {
  addToCart,
  removeFromCart,
  increaseQuantity,
  decreaseQuantity,
  clearCart, setCart,
  toggleDineInMode,
  setTableSelected,
  setRestaurantSelected,
} = cartSlice.actions;

export default cartSlice.reducer;
